import PropTypes from "prop-types";

import { Box } from "@material-ui/core";

import { formatOfficerName, parseDateFlexible } from "../../../utils/utils";
import styled from "styled-components";

const NarrativeSegment = ({
  segment,
  userId,
  isLast = false,
  nightMode = false,
  ...props
}) => {
  const borderStyle = isLast
    ? "none"
    : nightMode
    ? "1px solid grey"
    : "1px solid black";
  return (
    <Box display={"flex"} flexDirection="row" padding={0}>
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        flexGrow="1"
      >
        <Box display="flex" flexDirection={"row"}>
          <NarrativeTag data-testid="added-by">
            <em>
              Added by {formatOfficerName(segment?.officer)} at{" "}
              {parseDateFlexible(segment.createdAt)
                .local()
                .format("YYYY-MM-DD HH:mm")}
            </em>
          </NarrativeTag>

          {!!segment?.createdAt &&
            !!segment?.lastUpdatedAt &&
            segment?.createdAt !== segment?.lastUpdatedAt && (
              <NarrativeTag data-testid="updated-by">
                <em>
                  || Last Updated By {formatOfficerName(segment?.lastUpdatedBy)}{" "}
                  at{" "}
                  {parseDateFlexible(segment.lastUpdatedAt)
                    .local()
                    .format("YYYY-MM-DD HH:mm")}
                </em>
              </NarrativeTag>
            )}
        </Box>
        <Box style={{ borderBottom: borderStyle }} padding={1}>
          <p style={{ margin: 0, whiteSpace: "pre-line" }}>{segment.content}</p>
        </Box>
      </Box>
      {props.children}
    </Box>
  );
};

const NarrativeTag = styled.p`
  align-content: center;
  text-align: center;
  margin: 2px 5px 2px 2px;
  font-size: 0.7rem;
`;

export default NarrativeSegment;

NarrativeSegment.propTypes = {
  segment: PropTypes.shape({
    content: PropTypes.string.isRequired,
    createdAt: PropTypes.string.isRequired,
    lastUpdatedAt: PropTypes.string,
    lastUpdatedBy: PropTypes.object,
    officer: PropTypes.object.isRequired,
  }).isRequired,
  userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isLast: PropTypes.bool,
  nightMode: PropTypes.bool,
};
